import React from "react";
import { AnimatedShieldLogo } from "../../graphic/AnimatedShieldLogo";
import styles from "./SiteCardBox.scss";

/**
 * Centered heading (shield, eyebrow, title, subtitle) above a card, for onboarding steps and similar flows.
 * Wider than SiteCenterBox, with the content in a framed card.
 * @param footer – secondary actions shown under a divider at the bottom of the card
 */
export const SiteCardBox = ({ eyebrow, title, subtitle, footer, children }) => {
    return (
        <div className={styles.base}>
            <div className={styles.stack}>
                <div className={styles.head}>
                    <AnimatedShieldLogo className={styles.shield} />
                    {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
                    <h1 className={styles.title}>{title}</h1>
                    {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
                </div>
                <div className={styles.card}>
                    {children}
                    {footer ? <div className={styles.footer}>{footer}</div> : null}
                </div>
            </div>
        </div>
    );
};
